module.exports = __webpack_public_path__ + "img/logo-transparent.4f57b5ea.png";